import { render } from "./RecordTable.vue?vue&type=template&id=084c0425"
import script from "./RecordTable.vue?vue&type=script&lang=ts"
export * from "./RecordTable.vue?vue&type=script&lang=ts"
script.render = render

export default script